// extracted by mini-css-extract-plugin
module.exports = {"badges":"CategoryBadges_badges__2lgug","badges__svg":"CategoryBadges_badges__svg__qL7Hr","badges__badge":"CategoryBadges_badges__badge__1p0x_"};